export function translateNumber(value, language) {
  return Intl.NumberFormat(language).format(value);
}
